import { Type } from '@angular/core';
import { InputItemType } from '@libs/form/models';
import { AutocompleteComponent } from './autocomplete';
import { CheckboxComponent } from './checkbox';
import { DateComponent } from './date';
import { DateRangeComponent } from './date-range';
import { FileComponent } from './file';
import { PasswordCreateComponent } from './password-create';
import { QuantityCounterComponent } from './quantity-counter';
import { SelectComponent } from './select';
import { SelectTreeComponent } from './select-tree';
import { SelectionListComponent } from './selection-list';
import { TextComponent } from './text';
import { TextareaComponent } from './textarea';

export type InputItemComponent =
  | AutocompleteComponent
  | CheckboxComponent
  | DateComponent
  | DateRangeComponent
  | FileComponent
  | PasswordCreateComponent
  | QuantityCounterComponent
  | SelectComponent
  | SelectTreeComponent
  | SelectionListComponent
  | TextareaComponent
  | TextComponent;

export const InputItemsMap: Record<InputItemType, Type<InputItemComponent>> = {
  autocomplete: AutocompleteComponent,
  checkbox: CheckboxComponent,
  checkboxes: SelectionListComponent,
  date: DateComponent,
  dateRange: DateRangeComponent,
  email: TextComponent,
  file: FileComponent,
  password: TextComponent,
  passwordCreate: PasswordCreateComponent,
  quantityCounter: QuantityCounterComponent,
  radioButtons: SelectionListComponent,
  select: SelectComponent,
  selectTree: SelectTreeComponent,
  tel: TextComponent,
  text: TextComponent,
  textarea: TextareaComponent,
  number: TextComponent,
};
